module.exports = __webpack_public_path__ + "00c09220438400220eb7059d1c7a603f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/switch_active.png
// module id = 743
// module chunks = 0